(ns core.front.carbon
  {:clj-kondo/config {:linters {:refer                        {:level :off}
                                :unsorted-required-namespaces {:level :off}}}}
  (:require ["carbon-components-react/es/components/Accordion/Accordion" :default Accordion]
            ["carbon-components-react/es/components/Accordion/AccordionItem" :default AccordionItem]
            ["carbon-components-react/es/components/Breadcrumb/Breadcrumb" :default Breadcrumb]
            ["carbon-components-react/es/components/Breadcrumb/BreadcrumbItem" :default BreadcrumbItem]
            ["carbon-components-react/es/components/Button/Button" :default Button]
            ["carbon-components-react/es/components/Button/Button.Skeleton" :default ButtonSkeleton]
            ["carbon-components-react/es/components/Checkbox/Checkbox" :default Checkbox]
            ["carbon-components-react/es/components/ComboBox/ComboBox" :default ComboBox]
            ["carbon-components-react/es/components/ComposedModal/ComposedModal" :default ComposedModal :refer (ModalBody ModalFooter ModalHeader)]
            ["carbon-components-react/es/components/ContentSwitcher/ContentSwitcher" :default ContentSwitcher]
            ["carbon-components-react/es/components/CopyButton/CopyButton" :default CopyButton]
            ["carbon-components-react/es/components/DataTable/DataTable" :default DataTable]
            ["carbon-components-react/es/components/DataTable/Table" :default DataTable-Table]
            ["carbon-components-react/es/components/DataTable/TableBody" :default DataTable-TableBody]
            ["carbon-components-react/es/components/DataTable/TableCell" :default DataTable-TableCell]
            ["carbon-components-react/es/components/DataTable/TableContainer" :default DataTable-TableContainer]
            ["carbon-components-react/es/components/DataTable/TableExpandedRow" :default DataTable-TableExpandedRow]
            ["carbon-components-react/es/components/DataTable/TableExpandHeader" :default DataTable-TableExpandHeader]
            ["carbon-components-react/es/components/DataTable/TableExpandRow" :default DataTable-TableExpandRow]
            ["carbon-components-react/es/components/DataTable/TableHead" :default DataTable-TableHead]
            ["carbon-components-react/es/components/DataTable/TableHeader" :default DataTable-TableHeader]
            ["carbon-components-react/es/components/DataTable/TableRow" :default DataTable-TableRow]
            ["carbon-components-react/es/components/DataTableSkeleton/DataTableSkeleton" :default DataTableSkeleton]
            ["carbon-components-react/es/components/Dropdown/Dropdown" :default Dropdown]
            ["carbon-components-react/es/components/FileUploader/FileUploaderButton" :default FileUploaderButton]
            ["carbon-components-react/es/components/Form/Form" :default Form]
            ["carbon-components-react/es/components/FormGroup/FormGroup" :default FormGroup]
            ["carbon-components-react/es/components/FormLabel/FormLabel" :default FormLabel]
            ["carbon-components-react/es/components/Icon/Icon" :default Icon]
            ["carbon-components-react/es/components/InlineLoading/InlineLoading" :default InlineLoading]
            ["carbon-components-react/es/components/Link/Link" :default Link]
            ["carbon-components-react/es/components/Loading/Loading" :default Loading]
            ["carbon-components-react/es/components/Modal/Modal" :default Modal]
            ["carbon-components-react/es/components/MultiSelect/FilterableMultiSelect" :default FilterableMultiSelect]
            ["carbon-components-react/es/components/MultiSelect/MultiSelect" :default MultiSelect]
            ["carbon-components-react/es/components/Notification/Notification" :refer (InlineNotification ToastNotification)]
            ["carbon-components-react/es/components/ProgressIndicator/ProgressIndicator" :refer (ProgressIndicator ProgressStep)]
            ["carbon-components-react/es/components/ProgressIndicator/ProgressIndicator.Skeleton" :default ProgressIndicatorSkeleton]
            ["carbon-components-react/es/components/RadioButton/RadioButton" :default RadioButton]
            ["carbon-components-react/es/components/RadioButtonGroup/RadioButtonGroup" :default RadioButtonGroup]
            ["carbon-components-react/es/components/RadioTile/RadioTile" :default RadioTile]
            ["carbon-components-react/es/components/Select/Select" :default Select]
            ["carbon-components-react/es/components/Select/Select.Skeleton" :default SelectSkeleton]
            ["carbon-components-react/es/components/SelectItem/SelectItem" :default SelectItem]
            ["carbon-components-react/es/components/SelectItemGroup/SelectItemGroup" :default SelectItemGroup]
            ["carbon-components-react/es/components/SkeletonText/SkeletonText" :default SkeletonText]
            ["carbon-components-react/es/components/Slider/Slider" :default Slider]
            ["carbon-components-react/es/components/StructuredList/StructuredList" :refer (StructuredListCell StructuredListRow StructuredListBody StructuredListHead StructuredListWrapper)]
            ["carbon-components-react/es/components/StructuredList/StructuredList.Skeleton" :default StructuredListSkeleton]
            ["carbon-components-react/es/components/Switch/Switch" :default Switch]
            ["carbon-components-react/es/components/Tab/Tab" :default Tab]
            ["carbon-components-react/es/components/Tabs/Tabs" :default Tabs]
            ["carbon-components-react/es/components/Tabs/Tabs.Skeleton" :default TabsSkeleton]
            ["carbon-components-react/es/components/Tag/Tag" :default Tag]
            ["carbon-components-react/es/components/TextArea/TextArea" :default TextArea]
            ["carbon-components-react/es/components/TextInput/TextInput" :default TextInput]
            ["carbon-components-react/es/components/Tile/Tile" :refer (Tile)]
            ["carbon-components-react/es/components/TileGroup/TileGroup" :default TileGroup]
            ["carbon-components-react/es/components/Toggle/Toggle" :default Toggle]
            [clojure.string :as str]
            [core.front.portal :as portal]
            [potpuri.core :as p]
            [reagent.core :as r]
            [schema-tools.core :as st]
            [schema.core :as s]))

(s/defschema NumOrStr
  (s/cond-pre s/Num s/Str))

(s/defschema CommonReactOpts
  (st/optional-keys
    {:key           (s/cond-pre s/Num s/Str s/Keyword)
     :on-drag-over  (s/pred fn?)
     :on-drag-enter (s/pred fn?)
     :on-drag-start (s/pred fn?)
     :on-drag-end   (s/pred fn?)
     :draggable     s/Bool
     :ref           (s/pred fn?)
     ;; for cypress
     :data-cy       s/Str}))

;;; Loading
;;; ====================================================================================================================

(s/defschema LoadingOptions
  (merge
    CommonReactOpts
    {(s/optional-key :class-name)   s/Str
     (s/optional-key :active)       s/Bool
     (s/optional-key :with-overlay) s/Bool
     (s/optional-key :small)        s/Bool}))

(s/defn loading-spinner
  "Shows loading spinner. See `LoadingOptions` schema for available options.

    :class-name , :active , :with-overlay , :small"
  ([] (loading-spinner {}))
  ([opts :- LoadingOptions]
   [:> Loading opts]))

(s/defschema InlineLoadingOptions
  (merge
    CommonReactOpts
    {(s/optional-key :class-name)       s/Str
     (s/optional-key :success)          s/Bool
     (s/optional-key :description)      s/Str
     (s/optional-key :icon-description) s/Str
     (s/optional-key :on-success)       (s/pred fn?)
     (s/optional-key :success-delay)    s/Int}))

(s/defn inline-loading
  "See `InlineLoadingOptions` schema for available options.

  On top of basic 'spinner' usage this component can be used to fire on-success callbacks.
  For example setting `:success` prop to true, will call `:on-success`
  function after `:success-delay`.

  Default values in component:
    :success       false
    :successDelay  1500"
  [opts :- InlineLoadingOptions]
  [:> InlineLoading opts])

;;;; Icons
;;;; ===================================================================================================================

(s/defschema IconData
  (merge
    CommonReactOpts
    {:width    s/Str
     :height   s/Str
     :view-box s/Str
     :svg-data {:paths [{:d s/Str}]}}))

(s/defschema IconOptions
  (merge
    CommonReactOpts
    {:icon                          (s/conditional
                                      map? IconData
                                      :else s/Any)
     (s/optional-key :description)  s/Str
     (s/optional-key :aria-hidden)  s/Bool
     (s/optional-key :class-name)   s/Str
     (s/optional-key :fill)         s/Str
     (s/optional-key :fill-rule)    s/Keyword
     (s/optional-key :height)       s/Str
     (s/optional-key :name)         s/Str
     (s/optional-key :role)         s/Keyword
     (s/optional-key :style)        {s/Keyword s/Str}
     (s/optional-key :view-box)     s/Str
     (s/optional-key :width)        s/Str
     (s/optional-key :icon-ref)     s/Str
     (s/optional-key :on-click)     (s/pred fn?)
     (s/optional-key :focusable)    s/Bool
     (s/optional-key :stroke-width) s/Int}))

(s/defn icon
  "See IconOptions schema for available options.

   Draws an SVG element containing the data provided in :icon key.
   The :description key should contain a description of the icon and what it does in context (accessibility + tooltip).

   When using icons, all touch targets need to be 44px or higher.
   With that said, a developer can add padding to a touch target with CSS to meet the 44px requirement.

   Other options are primarily attributes for the SVG element.

   Default values are set for the following keys:
   :fill        grey
   :fill-rule   evenodd
   :role        img"
  [opts :- IconOptions]
  [:> Icon opts])


(defn- make-button-icon-props
  "button-props come from Carbon Button, icon-props are from our client code.
  These props needs some massaging before passing them to Icon."
  [button-props icon-props]
  (-> (merge button-props icon-props)
      ; TODO: Icon doesn't support these aria attributes atm
      (dissoc :className :aria-label)
      ; Carbon Button gives "bx--btn__icon" className by convenience.
      (update :class-name (comp str/trim str) " " (:className button-props))))


(defn- button-icon
  "Wrapper to create React component to be used in Carbon Button `renderIcon` props."
  [icon-props]
  (r/reactify-component
    (fn [props]
      (icon (->> (make-button-icon-props props icon-props)
                 (p/filter-vals some?))))))


;;;; Buttons
;;;; ===================================================================================================================

(s/defschema ButtonOptions
  (merge
    CommonReactOpts
    {(s/optional-key :id)               (s/cond-pre s/Str s/Keyword)
     (s/optional-key :aria-describedby) s/Str
     (s/optional-key :aria-label)       s/Str
     (s/optional-key :aria-selected)    s/Bool
     (s/optional-key :aria-invalid)     s/Bool
     (s/optional-key :aria-pressed)     s/Bool
     (s/optional-key :aria-expanded)    s/Bool
     (s/optional-key :aria-hidden)      s/Bool
     (s/optional-key :class-name)       s/Str
     (s/optional-key :on-click)         (s/pred fn?)
     (s/optional-key :disabled)         s/Bool
     (s/optional-key :size)             (s/enum :default :field :small)
     (s/optional-key :kind)             (s/enum :primary :secondary :tertiary :ghost :danger)
     (s/optional-key :href)             s/Str
     (s/optional-key :tab-index)        s/Int
     (s/optional-key :type)             (s/enum :button :reset :submit)
     (s/optional-key :role)             s/Str
     (s/optional-key :icon)             (s/conditional
                                          map? IconData
                                          :else s/Any)
     (s/optional-key :icon-description) s/Str
     (s/optional-key :children)         s/Any
     ;; Where to place icon - left or right of the content. The default is on the left.
     (s/optional-key :icon-position)    (s/enum :left :right)
     (s/optional-key :title)            s/Str
     (s/optional-key :download)         s/Str}))


(s/defn ^{:private true} button-icon-left
  [opts :- ButtonOptions
   & contents]
  (let [final-opts (-> opts
                       (dissoc :icon :icon-position)
                       ;; make right padding the same as left if icon present
                       (update :class-name #(if (:icon opts)
                                              (str % " pr-4 ")
                                              %)))
        icon       (when (:icon opts)
                     (icon {:class-name  "mr-4 fill-current"
                            :icon        (:icon opts)
                            :aria-hidden (not (str/blank? (apply str contents)))
                            :description (:icon-description opts)
                            :focusable   false}))]
    (apply vector :> Button final-opts [icon contents])))


(s/defn ^{:private true} button-icon-right
  [opts :- ButtonOptions
   & contents]
  (let [final-opts (-> opts
                       (dissoc :icon)
                       (dissoc :icon-position)
                       (p/assoc-if
                         :render-icon (let [icon (:icon opts)]
                                        (if (or (map? icon) (string? icon))
                                          (button-icon
                                            {:icon        (:icon opts)
                                             :aria-hidden (not (str/blank? (apply str contents)))
                                             :description (:icon-description opts)})
                                          icon))))]
    (apply vector :> Button final-opts contents)))

(defn add-icon-description [{:keys [icon icon-description] :as opts}]
  (if (and icon (not icon-description))
    (assoc opts :icon-description "")
    opts))

(s/defn button
  "See `ButtonOptions` schema for available options.

  If you provide :icon, you can provide :icon-description unless
  the icon is decorative (i.e. if the icon tells something that
  is not told by the button content)

   Default values are set for the following keys:
   :disabled   false
   :kind       :primary
   :tab-index  0
   :type       :button"
  ([opts :- ButtonOptions
    & contents]
   (let [opts          (add-icon-description opts)
         icon-position (-> opts
                           (get :icon-position :right))]
     (case icon-position
       :left (apply button-icon-left opts contents)
       :right (apply button-icon-right opts contents))))
  ([content :- s/Str]
   [:> Button {} content]))


(s/defn icon-button
  "Render a button that will contain only an icon.
   The icon is provided as a React component in the `:render-icon` property.
   Text in `:icon-description` is displayed in a small popup when hovering over the icon.
   For :ghost buttons, :is-selected controls Carbon's selected styling and aria-pressed."
  [opts :- (merge CommonReactOpts
                  {:render-icon      s/Any
                   :kind             (s/enum :primary :secondary :tertiary :ghost :danger)
                   :size             (s/enum :default :field :small)
                   :icon-description s/Str}
                  (st/optional-keys {:class-name  s/Str
                                     :is-selected s/Bool
                                     :on-click    (s/pred fn?)
                                     :disabled    s/Bool}))]
  [:> Button (assoc opts :has-icon-only true)])


(s/defn copy-button
  [opts :- (merge CommonReactOpts
                  (st/optional-keys {:class-name       s/Str
                                     :icon-description s/Str
                                     :feedback         s/Str
                                     :feedback-timeout s/Int
                                     :on-click         (s/pred fn?)}))]
  [:> CopyButton opts])


;;;; Forms
;;;; ===================================================================================================================

(s/defn form
  ([opts :- {(s/optional-key :id)         s/Str
             (s/optional-key :class-name) s/Str}
    & children]
   (apply vector :> Form opts children)))

(s/defschema FormLabelOptions
  (merge
    CommonReactOpts
    {(s/optional-key :class-name) s/Str
     (s/optional-key :id)         s/Str}))

(s/defn form-label
  [opts :- FormLabelOptions
   & text]
  (apply vector :> FormLabel opts text))

(s/defschema FormGroupOptions
  (merge
    CommonReactOpts
    {:legend-text                   s/Str
     (s/optional-key :class-name)   s/Str
     (s/optional-key :invalid)      s/Bool
     (s/optional-key :message)      s/Bool
     (s/optional-key :message-text) s/Str
     (s/optional-key :children)     s/Any}))

(s/defn form-group
  "See FormGroupOptions schema for available options.

   Default values are set for the following keys:
   :invalid    false
   :message    false"
  [opts :- FormGroupOptions
   & contents]
  (apply vector :> FormGroup opts contents))

(s/defschema CommonInputOptions
  {:label-text                  s/Str
   (s/optional-key :class-name) s/Str
   (s/optional-key :auto-focus) s/Bool
   (s/optional-key :required)   s/Bool
   (s/optional-key :on-change)  (s/pred fn?)
   (s/optional-key :on-click)   (s/pred fn?)
   (s/optional-key :on-blur)    (s/pred fn?)
   (s/optional-key :on-key-up)  (s/pred fn?)})


(s/defschema TextInputOptions
  (merge
    CommonReactOpts
    CommonInputOptions
    {:label-text                     s/Str
     :id                             s/Str
     (s/optional-key :disabled)      s/Bool
     (s/optional-key :type)          s/Keyword
     (s/optional-key :invalid)       s/Bool
     (s/optional-key :invalid-text)  s/Str
     (s/optional-key :helper-text)   s/Str
     (s/optional-key :light)         s/Bool
     (s/optional-key :default-value) (s/maybe NumOrStr)
     (s/optional-key :placeholder)   s/Str
     (s/optional-key :value)         (s/maybe NumOrStr)
     (s/optional-key :hide-label)    s/Bool
     (s/optional-key :on-change)     (s/pred fn?)
     (s/optional-key :on-click)      (s/pred fn?)
     (s/optional-key :class-name)    s/Str
     (s/optional-key :char-count)    s/Num
     (s/optional-key :max-length)    s/Num}))

(s/defn text-input
  "See TextInputOptions schema for available options.

   Default values are set for the following keys:
   :class-name 'bx--text__input'
   :disabled   false
   :type       :text
   :invalid    false
   :light      false"
  [opts :- TextInputOptions]
  [:> TextInput opts])

(s/defschema TextAreaOptions
  (merge
    CommonReactOpts
    CommonInputOptions
    {(s/optional-key :rows)          s/Int
     (s/optional-key :cols)          s/Int
     (s/optional-key :id)            s/Str
     (s/optional-key :disabled)      s/Bool
     (s/optional-key :invalid)       s/Bool
     (s/optional-key :invalid-text)  s/Str
     (s/optional-key :helper-text)   s/Str
     (s/optional-key :light)         s/Bool
     (s/optional-key :default-value) (s/maybe NumOrStr)
     (s/optional-key :placeholder)   s/Str
     (s/optional-key :value)         (s/maybe NumOrStr)
     (s/optional-key :hide-label)    s/Bool}))

(s/defn text-area
  "See TextAreaOptions schema for available options.

   Default values are set for the following keys:
   :rows       4
   :cols       50
   :disabled   false
   :invalid    false
   :light      false"
  [opts :- TextAreaOptions]
  [:> TextArea opts])

(s/defschema CheckboxOptions
  (merge
    CommonReactOpts
    {:id                                  (s/cond-pre s/Str s/Keyword)
     :label-text                          s/Str
     ;; Title for the label node
     (s/optional-key :title)              s/Str
     ;; Class name for the label node
     (s/optional-key :class-name)         s/Str
     ;; Class name for the wrapping element
     (s/optional-key :wrapper-class-name) s/Str
     (s/optional-key :on-change)          (s/pred fn?)
     ;; If checkbox is in indeterminate state
     (s/optional-key :indeterminate)      s/Bool
     (s/optional-key :checked)            s/Bool
     (s/optional-key :default-checked)    s/Bool
     (s/optional-key :disabled)           s/Bool
     (s/optional-key :hide-label)         s/Bool}))

(s/defn checkbox
  "See CheckboxOptions schema for available options.

   Default values are set for the following keys:
   :title         ''
   :indeterminate false"
  [opts :- CheckboxOptions]
  [:> Checkbox opts])

;; --- Carbon checkbox CSS workarounds -----------------------------------------
;; Tailwind classes that override Carbon Design System checkbox quirks
;; (vertical margins, nowrap labels, fixed heights) whenever a checkbox is
;; placed inside a custom layout (grid, flex, etc.).

(def carbon-checkbox-no-margin-class
  "Removes the default vertical margin from Carbon checkbox wrappers."
  "[&_.bx--checkbox-wrapper]:!my-0")

(def carbon-checkbox-wrap-label-class
  "Allows checkbox label text to wrap instead of staying on one line."
  "[&_.bx--checkbox-label]:!whitespace-normal")

(def carbon-checkbox-auto-height-class
  "Removes fixed height so wrapped content can expand."
  "[&_div]:!h-auto")

(def carbon-checkbox-center-pseudo-classes
  "Vertically centers the checkbox pseudo-elements for wrapped/multi-line labels."
  "[&_.bx--checkbox-label::before]:!top-1/2 [&_.bx--checkbox-label::before]:!-mt-2 [&_.bx--checkbox-label::after]:!top-1/2 [&_.bx--checkbox-label::after]:!-mt-2")

(s/defschema SelectOptions
  (merge CommonReactOpts
         {:id s/Str}
         (st/optional-keys
           {:label-text       s/Str
            :disabled         s/Bool
            ;; Draws a small inline component
            :inline           s/Bool
            :icon-description s/Str
            :invalid          s/Bool
            ;; Only sets the required attribute to the select element, does not affect the component otherwise
            :required         s/Bool
            :invalid-text     s/Str
            :helper-text      s/Str
            ;; Draws the component with light background
            :light            s/Bool
            :children         s/Any
            :class-name       s/Str
            :size             (s/enum :sm :md :lg)
            :on-change        (s/pred fn?)
            :default-value    s/Any
            :value            s/Any
            :hide-label       s/Bool
            :aria-label       s/Str
            :no-label         s/Bool
            :aria-labelledby  s/Str})))

(s/defschema SelectItemGroupOptions
  (merge
    CommonReactOpts
    {:label                       s/Str
     (s/optional-key :disabled)   s/Bool
     (s/optional-key :class-name) s/Str
     (s/optional-key :children)   s/Any}))

(s/defschema SelectItemOptions
  (merge
    CommonReactOpts
    {:text                        s/Str
     (s/optional-key :value)      s/Any
     (s/optional-key :disabled)   s/Bool
     (s/optional-key :hidden)     s/Bool
     (s/optional-key :class-name) s/Str
     (s/optional-key :id)         s/Str}))

(s/defn select
  "See SelectOptions schema for available options.

   This component differs from a dropdown by using a <select> as the underlying html element.

   Contents should be select-item-group and/or select-item components.

   Default values are set for the following keys:
   :disabled         false
   :inline           false
   :invalid          false
   :light            false
   :icon-description 'open list of options'"
  [opts :- SelectOptions
   & contents]
  (apply vector :> Select opts contents))

(s/defn select-item-group
  "See SelectItemGroupOptions schema for available options.

   Contents should be select-item components."
  [opts :- SelectItemGroupOptions
   & contents]
  (apply vector :> SelectItemGroup opts contents))

(s/defn select-item
  "See SelectItemOptions schema for available options."
  [opts :- SelectItemOptions]
  [:> SelectItem opts])

(s/defschema RadioButtonGroupOptions
  (merge
    CommonReactOpts
    {:name                              s/Str
     (s/optional-key :value-selected)   NumOrStr
     (s/optional-key :default-selected) NumOrStr
     (s/optional-key :disabled)         s/Bool
     (s/optional-key :on-change)        (s/pred fn?)
     (s/optional-key :class-name)       s/Str
     (s/optional-key :children)         s/Any
     (s/optional-key :orientation)      (s/enum :horizontal :vertical)}))

(s/defschema RadioButtonOptions
  (merge
    CommonReactOpts
    {:label-text                       s/Str
     :value                            NumOrStr
     :name                             s/Str
     (s/optional-key :id)              s/Str
     (s/optional-key :checked)         s/Bool
     (s/optional-key :default-checked) s/Bool
     (s/optional-key :disabled)        s/Bool
     (s/optional-key :on-change)       (s/pred fn?)
     (s/optional-key :class-name)      s/Str
     (s/optional-key :hide-label)      s/Bool}))

(s/defn radio-button-group
  "See RadioButtonGroupOptions schema for available options.

   Although you can set the checked prop on the Radio Button, when using the Radio Button component as a child
   of the Radio Button Group, either set the defaultSelected or valueSelected which will automatically set the
   selected prop on the corresponding Radio Button component. Use defaultSelected when you want a radio button
   to be selected initially, but don’t need to set it at a later time. If you do need to set it dynamically at
   a later time, then use the valueSelected property instead."
  [opts :- RadioButtonGroupOptions
   & contents]
  (apply vector :> RadioButtonGroup opts contents))

(s/defn radio-button
  "See RadioButtonOptions schema for available options."
  [opts :- RadioButtonOptions]
  [:> RadioButton opts])

;;;; Dropdowns
;;;; ===================================================================================================================

(s/defschema ComboBoxOptions
  (st/merge
    CommonReactOpts
    {:items       [s/Any]
     ; A function that gets the selected item as an argument
     :on-change   (s/pred fn?)
     :placeholder s/Str}
    (st/optional-keys {:title-text            s/Str
                       :disabled              s/Bool
                       ; Helper function passed to downshift that allows the library to render a
                       ; given item to a string label. By default, it extracts the `label` field
                       ; from a given item to serve as the item label in the list
                       :item-to-string        (s/pred fn?)
                       ; Use the white / light color version
                       :light                 s/Bool
                       ; A filter function that takes in the current input and an item and passes back
                       ; whether or not the item should be filtered.
                       :should-filter-item    (s/pred fn?)
                       ; Default or inline variant
                       :type                  (s/enum :default :inline)
                       :invalid               s/Bool
                       :invalid-text          s/Str
                       :aria-label            s/Str
                       :class-name            s/Str
                       :id                    s/Str
                       :initial-selected-item s/Any
                       :selected-item         s/Any
                       ; Specify a custom translation function that takes in a message identifier
                       ; and returns the localized string for the message
                       :translateWithId       (s/pred fn?)
                       ; Callback function to notify consumer when the text input changes.
                       ; This provides support to change available items based on the text.
                       :on-input-change       (s/pred fn?)
                       :size                  (s/enum :sm :md :lg)
                       :on-toggle-click       (s/pred fn?)})))

(s/defn combo-box
  "See ComboBoxOptions schema for available options.

   Default values are set for the following keys:
   :type               :default
   :disabled           false
   :aria-label         'ListBox input field'
   :item-to-string     item => { if (typeof item === 'string') { return item; } return item && item.label; }
   :should-filter-item ({ inputValue, item, itemToString }) => !inputValue || itemToString(item).toLowerCase().includes(inputValue.toLowerCase())"
  [opts :- ComboBoxOptions]
  [:> ComboBox opts])

(s/defschema DropdownOptions
  (merge
    CommonReactOpts
    {:id                                     s/Str
     :items                                  [s/Any]
     :label                                  s/Str
     (s/optional-key :title-text)            s/Str
     (s/optional-key :hide-label)            s/Bool
     (s/optional-key :class-name)            s/Str
     (s/optional-key :inline)                s/Bool
     (s/optional-key :disabled)              s/Bool
     ; Default or inline variant
     (s/optional-key :type)                  (s/enum :default :inline)
     ; Helper function passed to downshift that allows the library to render a
     ; given item to a string label. By default, it extracts the `label` field
     ; from a given item to serve as the item label in the list
     (s/optional-key :item-to-string)        (s/pred fn?)
     (s/optional-key :item-to-element)       (s/pred fn?)
     ; Use the white / light color version
     (s/optional-key :light)                 s/Bool
     (s/optional-key :initial-selected-item) s/Any
     (s/optional-key :on-change)             (s/pred fn?)
     (s/optional-key :render-selected-item)  (s/pred fn?)
     (s/optional-key :downshift-props)       {s/Keyword s/Any}
     (s/optional-key :selected-item)         s/Any}))

(s/defn dropdown
  "See DropdownOptions schema for available options.

   This component does not use a <select> as the underlying html element.

   Default values are set for the following keys:
   :type           :default
   :disabled       false
   :light          false
   :item-to-string item => { if (typeof item === 'string') { return item; } return item ? item.label : ''; }"
  [opts :- DropdownOptions]
  [:> Dropdown opts])

(s/defschema MultiSelectOptions
  (merge
    CommonReactOpts
    {:id                                      s/Str
     :items                                   [s/Any]
     ; Label is displayed in the input field itself
     :label                                   s/Str
     ; Title text is like label in other components
     (s/optional-key :title-text)             s/Str
     (s/optional-key :class-name)             s/Str
     (s/optional-key :disabled)               s/Bool
     (s/optional-key :compare-items)          (s/pred fn?)
     ; Specify the locale of the control. Used for the default `compareItems`
     ; used for sorting the list of items in the control.
     (s/optional-key :locale)                 s/Str
     ; Helper function passed to downshift that allows the library to render a
     ; given item to a string label. By default, it extracts the `label` field
     ; from a given item to serve as the item label in the list
     (s/optional-key :item-to-string)         (s/pred fn?)
     (s/optional-key :initial-selected-items) [s/Any]
     ;; Controlled selection; supported by MultiSelect (useSelection) but not by FilterableMultiSelect.
     (s/optional-key :selected-items)         [s/Any]
     (s/optional-key :sort-items)             (s/pred fn?)
     (s/optional-key :type)                   (s/enum :default :inline)
     (s/optional-key :light)                  s/Bool
     (s/optional-key :on-change)              (s/pred fn?)
     (s/optional-key :invalid)                s/Bool
     (s/optional-key :invalid-text)           s/Str}))

(s/defn multi-select
  "See MultiSelectOptions schema for available options.

   Defaults are similar to the dropdown component.
   NOTE: Default fn for item-to-string requires items to have a field called label, i.e. string items are not accepted."
  [opts :- MultiSelectOptions]
  [:> MultiSelect opts])

(s/defschema FilterableMultiSelectOptions
  (st/merge
    CommonReactOpts
    {:id    s/Str
     :items [s/Any]}
    (st/optional-keys
      {:placeholder            s/Str
       ; Title text is like label in other components
       :title-text             s/Str
       :class-name             s/Str
       :disabled               s/Bool
       :compare-items          (s/pred fn?)
       ; Specify the locale of the control. Used for the default `compareItems`
       ; used for sorting the list of items in the control.
       :locale                 s/Str
       :item-to-string         (s/pred fn?)
       :initial-selected-items [s/Any]
       :sort-items             (s/pred fn?)
       :type                   (s/enum :default :inline)
       :light                  s/Bool
       :size                   (s/enum :sm :md :lg)
       :on-change              (s/pred fn?)
       ; Function that filters the dropdown options based on the current input.
       ; Overriding this prop means that you have to handle the filtering logic
       ; when the user types in the text input. Otherwise, a default built-in
       ; filtering function will be used.
       :filter-items           (s/pred fn?)
       :invalid                s/Bool
       :invalid-text           s/Str})))

(s/defn filterable-multi-select
  "See FilterableMultiSelectOptions schema for available options.

   Defaults are similar to the multi-select component.
   NOTE: Default fn for item-to-string requires items to have a field called label, i.e. string items are not accepted."
  [opts :- FilterableMultiSelectOptions]
  [:> FilterableMultiSelect opts])

;;;
;;; Lists
;;; ====================================================================================================================


(s/defschema StructuredListCellOptions
  (merge
    CommonReactOpts
    {(s/optional-key :head)       s/Bool
     (s/optional-key :no-wrap)    s/Bool
     (s/optional-key :class-name) s/Str}))

(s/defn structured-list-cell
  [opts :- StructuredListCellOptions
   & children]
  (apply vector :> StructuredListCell opts children))

(s/defschema StructuredListRowOptions
  (merge
    CommonReactOpts
    {(s/optional-key :head)        s/Bool
     (s/optional-key :label)       s/Bool
     (s/optional-key :tab-index)   s/Int
     (s/optional-key :on-key-down) (s/pred fn?)
     (s/optional-key :class-name)  s/Str
     (s/optional-key :html-for)    s/Str}))

(s/defn structured-list-row
  [opts :- StructuredListRowOptions
   & children]
  (apply vector :> StructuredListRow opts children))

(s/defschema StructuredListBodyOptions
  (merge
    CommonReactOpts
    {(s/optional-key :head)        s/Bool
     (s/optional-key :on-key-down) (s/pred fn?)
     (s/optional-key :class-name)  s/Str}))

(s/defn structured-list-body
  [opts :- StructuredListBodyOptions
   & children]
  (apply vector :> StructuredListBody opts children))

(s/defn structured-list-head
  [opts :- {(s/optional-key :class-name) s/Str}
   & children]
  (apply vector :> StructuredListHead opts children))

(s/defschema StructuredListWrapperOptions
  (merge
    CommonReactOpts
    {(s/optional-key :border)     s/Bool
     (s/optional-key :selection)  s/Bool
     (s/optional-key :aria-label) s/Str
     (s/optional-key :class-name) s/Str}))

(s/defn structured-list-wrapper
  [opts :- StructuredListWrapperOptions
   & children]
  ; Seems that :aria-label option doesn't have effect... Strange...
  (apply vector :> StructuredListWrapper opts children))




;;;; Accordions
;;;; ===================================================================================================================

(s/defschema AccordionItemOptions
  (merge
    CommonReactOpts
    {:title                             s/Str
     (s/optional-key :class-name)       s/Str
     (s/optional-key :icon-description) s/Str
     (s/optional-key :open)             s/Bool
     (s/optional-key :on-click)         (s/pred fn?)
     (s/optional-key :on-heading-click) (s/pred fn?)
     (s/optional-key :children)         s/Any}))

(s/defschema AccordionOptions
  {(s/optional-key :class-name) s/Str
   (s/optional-key :children)   s/Any})

(s/defn accordion-item
  "See AccordionItemOptions schema for available options.

   Default values are set for the following keys:
   :open             false
   :icon-description 'Expand/Collapse'"
  [opts :- AccordionItemOptions
   & contents]
  (apply vector :> AccordionItem opts contents))

(s/defn accordion
  "See AccordionOptions schema for available options.
   Provide accordion-item components as contents."
  [opts :- AccordionOptions
   & contents]
  (apply vector :> Accordion opts contents))

;;;; Content switching
;;;; ===================================================================================================================

(s/defschema ContentSwitcherOptions
  (merge
    CommonReactOpts
    {(s/optional-key :children)       s/Any
     (s/optional-key :class-name)     s/Str
     (s/optional-key :on-change)      (s/pred fn?)
     (s/optional-key :selected-index) s/Int}))

(s/defschema SwitchOptions
  (st/merge
    CommonReactOpts
    {:text s/Str}
    (st/optional-keys {:data-cy     s/Str
                       :data-text   s/Str
                       :aria-label  s/Str
                       :index       s/Int
                       :name        NumOrStr
                       :disabled    s/Bool
                       :class-name  s/Str
                       :on-click    (s/pred fn?)
                       :on-key-down (s/pred fn?)
                       :selected    s/Bool})))

(s/defn content-switcher
  "See ContentSwitcherOptions schema for available options.
   Provide switch components as contents."
  [opts :- ContentSwitcherOptions
   & contents]
  (apply vector :> ContentSwitcher opts contents))

(s/defn switch
  "See SwitchOptions schema for available options.

   Default values are set for the following keys:
   :kind  :anchor"
  [opts :- SwitchOptions]
  [:> Switch (-> opts
                 (assoc :data-text (:text opts)) ; Needed for CSS hack to fix width between regular/bold font weights
                 (update :aria-label (fnil identity (:text opts))))]) ; Always set default to prevent double reading

;;;
;;; Link
;;; ====================================================================================================================

(s/defschema LinkOptions
  (merge
    CommonReactOpts
    {(s/optional-key :href)       (s/maybe s/Str)
     (s/optional-key :id)         s/Str
     (s/optional-key :class-name) s/Str
     (s/optional-key :target)     s/Str
     (s/optional-key :type)       s/Str
     (s/optional-key :rel)        s/Str
     (s/optional-key :ping)       s/Any
     (s/optional-key :media)      s/Str
     (s/optional-key :hreflang)   s/Str
     (s/optional-key :download)   s/Str
     (s/optional-key :on-click)   (s/pred fn?)
     (s/optional-key :aria-label) s/Str}))

(s/defn link
  "Link component. See `LinkOptions` schema for options."
  [opts :- LinkOptions
   & contents]
  (when-not (and (contains? opts :href) (not (:href opts)))
    (apply vector :> Link opts contents)))

;;;
;;; Progress
;;; ====================================================================================================================

(s/defschema ProgressIndicatorOptions
  (merge
    CommonReactOpts
    {(s/optional-key :class-name)    s/Str
     (s/optional-key :current-index) s/Int})) ; Index can also bet set via progress-step's `current`

(s/defn progress-indicator
  "Create ProgressIndicator. Childs are ProgressSteps."
  [opts :- ProgressIndicatorOptions
   & progress-step-children]
  (apply vector :> ProgressIndicator opts progress-step-children))

(s/defschema ProgressStepOptions
  (merge
    CommonReactOpts
    {:label                         s/Str
     (s/optional-key :class-name)   s/Str
     (s/optional-key :description)  s/Str
     (s/optional-key :current)      s/Bool
     (s/optional-key :complete)     s/Bool
     (s/optional-key :render-label) (s/pred fn?)}))

(s/defn progress-step
  [opts :- ProgressStepOptions]
  [:> ProgressStep opts])


;;;
;;; Data Table
;;; ====================================================================================================================


(s/defschema DataTableOptions
  (merge
    CommonReactOpts
    {:rows                                [{s/Any s/Any}]
     :headers                             [{:key    (s/cond-pre s/Keyword s/Str)
                                            :header s/Str}]
     :is-sortable                         s/Bool
     (s/optional-key :render)             (s/pred fn?)
     (s/optional-key :should-show-border) s/Bool
     (s/optional-key :short)              s/Bool
     (s/optional-key :locale)             s/Str
     (s/optional-key :translate-with-id)  (s/pred fn?)
     (s/optional-key :filter-rows)        (s/pred fn?)
     (s/optional-key :sort-row)           (s/pred fn?)}))

(s/defn data-table
  "DataTable component, see `DataTableOptions` for options.
  You must provide :rows and :headers as options.

  Default values for options:
    :sortRow          defaultSortRow
    :filterRows       defaultFilterRows
    :locale           'en'
    :short            false
    :shouldShowBorder true"
  [opts :- DataTableOptions
   & children]
  (apply vector :> DataTable opts children))

(s/defn table-container
  ([children]
   (table-container {} children))
  ([opts :- {(s/optional-key :title)      s/Str
             (s/optional-key :class-name) s/Str}
    & children]
   (apply vector :> DataTable-TableContainer opts children)))



(s/defn table
  [opts :- (merge
             CommonReactOpts
             {(s/optional-key :id)                   s/Str
              (s/optional-key :class-name)           s/Str
              (s/optional-key :container-class-name) s/Str})
   & children]
  (apply vector :> DataTable-Table opts children))


(s/defn table-head
  "Present <thead> HTML tag"
  [opts :- {(s/optional-key :class-name) s/Str}
   & children]
  (apply vector :> DataTable-TableHead opts children))


(s/defschema TableHeaderOptions
  "Auto generated! Use
  ```
  (js->clj (getHeaderProps #js {:header   (clj->js header)
                                :children (:header header)})
           :keywordize-keys true)
  ```"
  (merge
    CommonReactOpts
    {:sortDirection                                (s/enum "DESC" "ASC" "NONE")
     :isSortable                                   s/Bool
     :isSortHeader                                 s/Bool
     (s/optional-key :onClick)                     (s/pred fn?)
     (s/optional-key :class-name)                  s/Str
     (s/optional-key :icon-class-name)             s/Str
     (s/optional-key :icon-description-ascending)  s/Str
     (s/optional-key :icon-description-descending) s/Str
     (s/optional-key :children)                    s/Any}))

(s/defn table-header
  "Present <th> HTML tag.

   Provide a, `:onClick` handler if header `:isSortable`."
  [opts :- TableHeaderOptions
   & children]
  (apply vector :> DataTable-TableHeader opts children))


(s/defn table-expand-header
  "Just placeholder for expand row button in empty first header cell"
  []
  [:> DataTable-TableExpandHeader])


(s/defschema TableExpandRowOptions
  "Auto generated! Use
  ```
  (js->clj (getRowProps #js {:row (clj->js row)})
           :keywordize-keys true)
  ```"
  (merge
    CommonReactOpts
    {:isExpanded            s/Bool
     :onExpand              (s/pred fn?)
     :ariaLabel             s/Str
     :isSelected            s/Bool
     :expandIconDescription s/Str
     :disabled              s/Any}))

(s/defn table-expand-row
  "Like ordinary `table-row`, but with expand button in first column.  See `TableExpandRowOptions`"
  [opts :- TableExpandRowOptions
   & children]
  (apply vector :> DataTable-TableExpandRow opts children))


(s/defn table-expanded-row
  "Use this to show detailed row info.
  Usually inside
  ```
  (when (:isExpanded row)
    ...)
  ```
  block."
  [opts :- (st/merge CommonReactOpts {(s/optional-key :col-span) (s/cond-pre s/Int s/Str)})
   & children]
  (apply vector :> DataTable-TableExpandedRow opts children))


(s/defn table-body
  "Present <tbody> HTML tag"
  [opts :- {(s/optional-key :class-name) s/Str}
   & children]
  (apply vector :> DataTable-TableBody opts children))


(s/defschema TableRowOptions
  (merge
    CommonReactOpts
    {(s/optional-key :header)     s/Bool
     (s/optional-key :class-name) s/Str
     (s/optional-key :even)       s/Bool
     (s/optional-key :on-click)   (s/pred fn?)}))

(s/defn table-row
  "TableRow. Embed elements as children to form a row. See `TableRowOptions`"
  [opts :- TableRowOptions
   & children]
  (apply vector :> DataTable-TableRow opts children))


(s/defschema TableCellOptions
  (merge
    CommonReactOpts
    {(s/optional-key :class-name) s/Str
     (s/optional-key :col-span)   s/Int}))


(s/defn table-cell
  "TableCell. Children are content inside cell. See `TableCellOptions`"
  [opts :- TableCellOptions
   & children]
  (apply vector :> DataTable-TableCell opts children))


(s/defschema DataTableSkeletonOptions
  {(s/optional-key :column-count) s/Int
   (s/optional-key :row-count)    s/Int
   (s/optional-key :compact)      s/Bool
   (s/optional-key :zebra)        s/Bool})


(s/defn data-table-skeleton
  "DataTableSkeleton component provides skeleton behaviour.
   See `DataTableSkeletonOptions` for more opts."
  ([]
   (data-table-skeleton {}))
  ([opts :- DataTableSkeletonOptions]
   [:> DataTableSkeleton opts]))

;;;
;;; Skeletons
;;; ====================================================================================================================


(s/defschema SkeletonTextOptions
  (merge
    CommonReactOpts
    {(s/optional-key :class-name) s/Str
     (s/optional-key :paragraph)  s/Bool
     (s/optional-key :width)      s/Str
     (s/optional-key :heading)    s/Bool
     (s/optional-key :line-count) s/Int
     (s/optional-key :on-click)   (s/pred fn?)}))

(s/defn skeleton-text
  "SkeletonText component provides skeleton behaviour.
   Give `:paragraph true` if you want to have multiple lines.

   See `SkeletonTextOptions` for more opts."
  ([]
   (skeleton-text {}))
  ([opts :- SkeletonTextOptions]
   [:> SkeletonText opts]))

(s/defn progress-indicator-skeleton
  []
  [:> ProgressIndicatorSkeleton])


(s/defn select-skeleton
  ([] (select-skeleton {}))
  ([opts :- {(s/optional-key :hide-label) s/Bool}]
   [:> SelectSkeleton opts]))

(s/defn button-skeleton
  ([] (button-skeleton {}))
  ([opts :- {(s/optional-key :small) s/Bool
             (s/optional-key :href)  s/Str}]
   [:> ButtonSkeleton opts]))

(s/defn structured-list-skeleton []
  [:> StructuredListSkeleton])

;;;
;;; Tiles
;;; ====================================================================================================================

(s/defn tile
  [opts :- {(s/optional-key :class-name) s/Str}
   & children]
  (apply vector :> Tile opts children))

(s/defschema RadioTileOptions
  (merge
    CommonReactOpts
    {:value                            (s/cond-pre s/Int s/Keyword s/Str)
     (s/optional-key :id)              s/Str
     (s/optional-key :name)            s/Str
     (s/optional-key :class-name)      s/Str
     (s/optional-key :on-change)       (s/pred fn?)
     (s/optional-key :checked)         s/Bool
     (s/optional-key :default-checked) s/Bool}))

(s/defn radio-tile
  [opts :- RadioTileOptions
   & children]
  (apply vector :> RadioTile opts children))

(s/defschema TileGroupOptions
  (merge
    CommonReactOpts
    {(s/optional-key :class-name)       s/Str
     (s/optional-key :default-selected) (s/cond-pre s/Int s/Keyword s/Str)
     (s/optional-key :value-selected)   (s/cond-pre s/Int s/Keyword s/Str)
     (s/optional-key :legend)           s/Str
     (s/optional-key :name)             s/Str
     (s/optional-key :on-change)        (s/pred fn?)}))

(s/defn tile-group
  [opts :- TileGroupOptions
   & children]
  (apply vector :> TileGroup opts children))








;;;
;;; Notifications
;;; =======================================================================================================================

(s/defschema ToastNotificationOptions
  (merge
    CommonReactOpts
    {(s/optional-key :kind)                  (s/enum :error :info :success :warning)
     (s/optional-key :title)                 s/Str
     (s/optional-key :subtitle)              s/Any
     (s/optional-key :caption)               s/Any
     (s/optional-key :role)                  s/Str
     (s/optional-key :notification-type)     s/Str
     (s/optional-key :icon-description)      s/Str
     (s/optional-key :on-close-button-click) (s/pred fn?)
     (s/optional-key :hide-close-button)     s/Bool
     (s/optional-key :timeout)               s/Int
     (s/optional-key :class-name)            s/Str}))

(s/defn toast-notification
  "Toast Notification component, see `ToastNotificationOptions` for options.

  Default values for options:
    :kind              'error'
    :title             'provide a title'
    :subtitle          'provide a subtitle'
    :caption           'provide a caption'
    :role              'alert'
    :notification-type 'toast'
    :icon-description  'closes notification'
    :hide-close-button false
    :timeout           0"
  [opts :- ToastNotificationOptions]
  [:> ToastNotification opts])

(s/defschema InlineNotificationOptions
  (merge
    CommonReactOpts
    {:kind                                   (s/enum :error :info :success :warning)
     :title                                  s/Str
     :subtitle                               s/Any
     (s/optional-key :actions)               s/Any
     (s/optional-key :role)                  s/Str
     (s/optional-key :notification-type)     s/Str
     (s/optional-key :icon-description)      s/Str
     (s/optional-key :on-close-button-click) (s/pred fn?)
     (s/optional-key :hide-close-button)     s/Bool
     (s/optional-key :class-name)            s/Str}))

(s/defn inline-notification
  "Inline Notification component, see `InlineNotificationOptions` for options.

  Default values for options:
    :role              'alert'
    :notification-type 'inline'
    :icon-description  'closes notification'
    :hide-close-button false"
  [opts :- InlineNotificationOptions
   & [child]]
  (cond-> [:> InlineNotification opts]
    child (conj child)))


;;;
;;; Breadcrumb
;;; ====================================================================================================================

(s/defn breadcrumb
  [opts :- {(s/optional-key :no-trailing-slash) s/Bool
            (s/optional-key :class-name)        s/Str}
   & children]
  (apply vector :> Breadcrumb opts children))

(s/defn breadcrumb-item
  [opts :- {(s/optional-key :href)            s/Str
            (s/optional-key :class-name)      s/Str
            (s/optional-key :is-current-page) s/Bool
            (s/optional-key :aria-current)    (s/enum :page :step :location :date :time)}
   & children]
  (apply vector :> BreadcrumbItem opts children))


;;;
;;; Modal
;;; ====================================================================================================================


(s/defschema ModalOptions
  (merge
    CommonReactOpts
    {(s/optional-key :id)                      s/Str
     (s/optional-key :class-name)              s/Str
     (s/optional-key :open)                    s/Bool
     (s/optional-key :passive-modal)           s/Bool
     (s/optional-key :danger)                  s/Bool
     (s/optional-key :should-submit-on-enter)  s/Bool
     (s/optional-key :primary-button-disabled) s/Bool

     (s/optional-key :modal-heading)    s/Str
     (s/optional-key :modal-label)      s/Any
     (s/optional-key :modal-aria-label) s/Str
     (s/optional-key :aria-label)       s/Str

     (s/optional-key :primary-button-text)    s/Str
     (s/optional-key :secondary-button-text)  s/Str
     (s/optional-key :selector-primary-focus) s/Str
     (s/optional-key :icon-description)       s/Str

     (s/optional-key :on-blur)             (s/pred fn?)
     (s/optional-key :on-click)            (s/pred fn?)
     (s/optional-key :on-focus)            (s/pred fn?)
     (s/optional-key :on-key-down)         (s/pred fn?)
     (s/optional-key :on-request-close)    (s/pred fn?)
     (s/optional-key :on-request-submit)   (s/pred fn?)
     (s/optional-key :on-secondary-submit) (s/pred fn?)}))


(s/defn modal
  "Modal component, see `ModalOptions` for options.

  Check also `composed-modal`, it might better suit your needs. Grep for some usages.

  Default values for options:
    :on-request-close        () => {}
    :on-request-submit       () => {}
    :primary-button-disabled false
    :on-key-down             () => {}
    :passive-modal           false
    :icon-description        'Close the modal'
    :modal-heading           ''
    :modal-label             ''
    :selector-primary-focus  '[data-modal-primary-focus]'"
  [opts :- ModalOptions
   & children]
  (portal/render-in-portal (apply vector :> Modal opts children) "modal-container"))

(defn composed-modal
  [opts & children]
  (portal/render-in-portal (apply vector :> ComposedModal opts children) "modal-container"))

(defn modal-body
  [opts & children]
  (apply vector :> ModalBody opts children))

(defn modal-header
  [opts & children]
  (apply vector :> ModalHeader opts children))

(defn modal-footer
  [opts & children]
  (apply vector :> ModalFooter opts children))

;;;
;;; Slider
;;; =========================================================================

(defn slider
  [opts & children]
  (apply vector :> Slider opts children))

;;;
;;; Tag
;;; ==========================================================================

(defn tag
  "Generate a Tag component.
   Allowed options:
    :class-name  additional CSS class
    :type        \"red\", \"magenta\", \"purple\", \"blue\", \"cyan\", \"teal\", \"green\", \"gray\", \"cool-gray\", \"warm-gray\""
  [opts & contents]
  (apply vector :> Tag opts contents))



;;;
;;; Toggle
;;; ==========================================================================

(s/defschema ToggleOptions
  (merge
    CommonReactOpts
    {:id                               s/Str
     (s/optional-key :toggled)         s/Bool
     (s/optional-key :disabled)        s/Bool
     (s/optional-key :class-name)      s/Str
     (s/optional-key :aria-label)      s/Str
     (s/optional-key :aria-labelledby) s/Str
     (s/optional-key :label-text)      s/Any
     (s/optional-key :labelA)          s/Str
     (s/optional-key :labelB)          s/Str
     (s/optional-key :on-change)       (s/pred fn?)
     (s/optional-key :on-toggle)       (s/pred fn?)
     (s/optional-key :size)            (s/eq :sm)}))

(s/defn toggle
  "class-name: 'some-class',
  aria-label: text('ARIA label (ariaLabel)', 'Label Name'),
  on-change: action('onChange'),
  on-toggle: action('onToggle'),"
  [opts :- ToggleOptions]
  [:> Toggle opts])

;;
;; Tabs
;;

(s/defschema TabsOptions
  (st/merge
    CommonReactOpts
    (st/optional-keys
      {:icon-description       s/Str
       :role                   s/Str
       :trigger-href           s/Str
       :selected               s/Int
       :aria-label             s/Str
       :class-name             s/Str
       :hidden                 s/Bool
       :tab-content-class-name s/Str
       :on-click               (s/pred fn?)
       :on-key-down            (s/pred fn?)
       :on-selection-change    (s/pred fn?)})))


(s/defn tabs
  "Tabs are used to quickly navigate between views within the same context. Create individual Tab components for each item in the Tabs list."
  [opts :- TabsOptions
   & children]
  (apply vector :> Tabs opts children))


(s/defschema TabOptions
  (st/merge
    CommonReactOpts
    (st/optional-keys
      {:class-name              s/Str
       :role                    s/Str
       :label                   s/Any
       :tab-index               s/Int
       :index                   s/Int
       :href                    s/Str
       :disabled                s/Bool
       :selected                s/Bool
       :on-click                (s/pred fn?)
       :on-key-down             (s/pred fn?)
       :handle-tab-click        (s/pred fn?)
       :handle-tab-anchor-focus (s/pred fn?)
       :handle-tab-key-down     (s/pred fn?)
       :render-anchor           (s/pred fn?)})))

(s/defn tab
  "Tab, use inside tabs."
  [opts :- TabOptions
   & contents]
  (apply vector :> Tab opts contents))


(defn tabs-skeleton []
  [:> TabsSkeleton])


(defn file-uploader-button [opts]
  [:> FileUploaderButton opts])
